module.exports = __webpack_public_path__ + "static/media/facundo_medina.7b81ba53.jpg";